/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type ProjectSettingsServiceDeskChatSettingsType from '@jira/spa-apps__project-settings-service-desk-chat-settings/src/ServiceDeskChatSettingsPage.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyProjectSettingsServiceDeskChatSettings: LazyComponent<() => React.JSX.Element> =
	lazyForPaint<typeof ProjectSettingsServiceDeskChatSettingsType>(
		() =>
			import(
				/* webpackChunkName: "async-project-settings-service-desk-chat-settings", jiraSpaEntry: "async-project-settings-service-desk-chat-settings" */ '@jira/spa-apps__project-settings-service-desk-chat-settings/src/ServiceDeskChatSettingsPage.tsx'
			),
	);

const AsyncProjectSettingsServiceDeskChatSettings = (): React.JSX.Element => (
	<LazyPage
		Page={LazyProjectSettingsServiceDeskChatSettings}
		pageId="project-settings-widget-settings"
		shouldShowSpinner
	/>
);

export default AsyncProjectSettingsServiceDeskChatSettings;
